module.exports = __webpack_public_path__ + "static/media/nissan-parking-selected.4a6fb2e8.svg";